//@ts-strict-ignore
import React from 'react';
import { ImportedEbayOrder } from '../../graphql/entities';
import Workspace from '../../components/Workspace/Workspace';
import fieldMetaData from '../../graphql/schema/fieldMetaData';
import Formatters from '../../components/grid-addons/formatters';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { Direction, IImportedEbayOrder } from '../../graphql/schema/p4types';
import { useImportedOrderWorkspaceActions } from '../../actions/sales/ImportedOrderWorkspaceAction';
import ImportEbayOrderRetryMutation from '../../graphql/mutations/sales/ImportEbayOrderRetryMutation.graphql';
import { WorkspaceActionButtons } from '../../components/Workspace/WorkspaceActionButtons';
import { Paths } from '../../@types/keyOfNested';
import { DispatchSource } from '../../components/ActionButtons/dispatch/DispatchModal';

const IMPORTED_EBAY_ORDER_FIELD_NAMES: Array<Paths<IImportedEbayOrder>> = [
  'createdAt',
  'ebayConfiguration.name',
  'orderReference',
  'salesOrder.orderNumber',
  'orderImportFailureReason',
  'failureDescription',
  'shippedAt',
  'resolved',
];

const IMPORTED_EBAY_ORDER_COLUMN_OVERRIDES = {
  orderImportFailureReason: {
    options: fieldMetaData.OrderImportFailureReason,
    formatter: Formatters.EnumFormatter,
  },
};

const ImportEbayOrderWorkspaceActions = (props) => {
  const [actions, modals] = useImportedOrderWorkspaceActions({
    retryMutation: ImportEbayOrderRetryMutation,
    type: 'importedEbayOrders',
    dispatchSource: DispatchSource.ImportedEbayOrderWorkspace,
  });

  return (
    <>
      {modals}
      <WorkspaceActionButtons {...props} actionButtons={actions} />
    </>
  );
};

const ImportedEbayOrderWorkspace = (props) => {
  const workspaceProps = useWorkspace<IImportedEbayOrder>(props, ImportedEbayOrder, {
    columns: IMPORTED_EBAY_ORDER_FIELD_NAMES,
    columnOverrides: IMPORTED_EBAY_ORDER_COLUMN_OVERRIDES,
    initialSortColumn: 'createdAt',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={ImportedEbayOrder.type}
      title={ImportedEbayOrder.title}
      formUrl={ImportedEbayOrder.formUrl}
      defaultQuery={ImportedEbayOrder.workspace}
      entity={ImportedEbayOrder}
      permittedOperations={ImportedEbayOrder.operations}
      {...workspaceProps}
      {...props}
      workspaceActionButtonsHOC={ImportEbayOrderWorkspaceActions}
    />
  );
};

export default ImportedEbayOrderWorkspace;
